<template>
  <v-row>
    <v-col v-if="loading" cols="12" class="text-center">
      <v-progress-circular indeterminate size="64" color="primary" />
    </v-col>
    <template v-else>
      <v-col cols="12">
        <card-title class="pt-0">
          Service Alert for {{ alert.serviceDomain }}
          <router-link class="body-2 pl-md-2" :to="{ name: 'hosting_alerts' }">
            Back to all alerts
          </router-link>
        </card-title>
      </v-col>
      <v-col cols="12" class="pt-0">
        <alert-card :alert="alert" />
      </v-col>
      <v-col cols="12" class="pt-8">
        <h3 class="mb-0">
          Your Options
        </h3>
      </v-col>
      <v-col v-if="selfResolveAvailable" cols="12" md="4">
        <self-resolve :steps="alertData.option_selfresolve" />
      </v-col>
      <v-col v-if="upgradeAvailable" cols="12" md="4">
        <upgrade :alert="alertData" />
      </v-col>
      <v-col v-if="helpAvailable" cols="12" md="4">
        <help :alert="alertData" />
      </v-col>
    </template>
  </v-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import amapi from 'Api/amapi'
import AlertCard from '@/components/Alerts/AlertCard'
import SelfResolve from '@/components/Alerts/Sections/SelfResolve'
import Upgrade from '@/components/Alerts/Sections/Upgrade'
import Help from '@/components/Alerts/Sections/Help'
import CardTitle from 'Components/Global/GGCardTitle'

export default {
  name: 'AlertView',
  components: {
    CardTitle,
    AlertCard,
    SelfResolve,
    Upgrade,
    Help
  },
  props: {
    alertId: {
      required: true,
      type: [String, Number]
    }
  },
  data () {
    return {
      loading: false,
      alertData: {}
    }
  },
  computed: {
    ...mapGetters({
      alerts: 'alerts',
      session_ready: 'session_ready',
      services: 'services'
    }),
    alert () {
      const alert = this.alerts.find(a => a.id == this.alertId)
      const service = this.services.find(s => s.id == alert.serviceID)
      return {
        ...alert,
        service: `${service.name} - ${service.domain}`,
        serviceDomain: service.domain
      }
    },
    selfResolveAvailable () {
      return Array.isArray(this.alertData.option_selfresolve) && this.alertData.option_selfresolve.length > 0
    },
    upgradeAvailable () {
      return this.alertData.option_upgrade == 1
    },
    helpAvailable () {
      return this.alertData.option_ticket == 1
    }
  },
  methods: {
    ...mapActions({
      reportError: 'reportError'
    }),
    async alertView () {
      this.loading = true
      try {
        const response = await amapi.makecall('alert_view', { id: this.alertId })
        this.alertData = response.alert
      } catch (e) {
        this.reportError(e)
      } finally {
        this.loading = false
      }
    }
  },
  watch: {
    alert (val) {
      if (!val) {
        this.$router.replace({ name: 'dashboard' })
      }
    }
  },
  mounted () {
    this.alertView()
  }
}
</script>
